<div class="card">
  <div class="card-body">
    <h5>{{ "DANH SÁCH THIẾT BỊ TRONG KHO" | translate }}</h5>

    <div class="d-flex">
      <div class="row">
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Mã thiết bị" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.serial_number"
            placeholder="Mã thiết bị"
            (change)="submitFilter()"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{ "Mã sim" | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.sim4g_imsi"
            placeholder="Mã sim"
            (change)="submitFilter()"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{ "Trạng thái liên kết" | translate }}</label>
          <ng-select
            [(ngModel)]="filter.status"
            [clearable]="true"
            (change)="submitFilter()"
          >
            <ng-option value="" hidden>{{
              "Chọn trạng thái" | translate
            }}</ng-option>
            <ng-option value="1">{{ "Đã liên kết" | translate }}</ng-option>
            <ng-option value="0">{{ "Chưa liên kết" | translate }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Loại thiết bị" | translate
          }}</label>
          <ng-select
            [(ngModel)]="filter.device_type_id"
            [clearable]="true"
            (change)="submitFilter()"
          >
            <ng-option value="" hidden>{{
              "Chọn loại thiết bị" | translate
            }}</ng-option>
            <ng-option
              *ngFor="let item of listDevicesFilter"
              [value]="item.value"
              >{{ item.label }}</ng-option
            >
          </ng-select>
        </div>
        <div class="form-group col-4" *ngIf="canManageStock">
          <label for="validationCustom01">{{
            "Import thiết bị từ file" | translate
          }}</label>
          <div class="d-flex">
            <input
              type="file"
              (change)="onFileChange($event)"
              accept=".xlsx, .xls"
              class="form-control mr-2"
              placeholder="Import thiết bị từ file"
            />
            <button class="btn btn-success mb-2" (click)="openModal(content)">
              Nhập
            </button>
          </div>
        </div>
        <div class="col-4">
          <div style="min-width: 200px">
            <div class="form-group">
              <label for="validationCustom01" class="d-block">&nbsp;</label>
              <button class="btn btn-primary" (click)="submitFilter()">
                {{ "PAGE.REPORT.Search" | translate }}
              </button>
              <button
                class="btn btn-dark ml-2"
                *ngIf="searching"
                (click)="clearFilter()"
              >
                {{ "FORM.Clear" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th>Thông tin thiết bị</th>
            <th>Thông tin SIM</th>
            <th>Trạng thái liên kết</th>
            <th>Tình trạng sử dụng</th>
            <th *ngIf="role === 'user'">{{ "Phiên bản" | translate }}</th>
            <th>{{ "Ngày tạo" | translate }}</th>
            <th width="100" class="table-column" *ngIf="canManageStock">
              {{ "Quản lý" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
            <td>
              <button
                type="button"
                class="stock-serial-link"
                (click)="showDeviceLinkHistory(data, contentDeviceLinkHistory)"
              >
                {{ data.serial_number }}
              </button>
              <div class="stock-info-secondary" *ngIf="data.model || data.type">
                <ng-container *ngIf="data.model">{{ data.model }}</ng-container>
                <ng-container *ngIf="data.model && data.type"> ({{ data.type }})</ng-container>
                <ng-container *ngIf="!data.model">{{ data.type }}</ng-container>
              </div>
            </td>
            <td>
              <div class="stock-info-primary" *ngIf="data.sim4g_imsi">
                {{ data.sim4g_imsi }}
              </div>
              <div class="stock-info-secondary" *ngIf="data.network_provider">
                {{ data.network_provider }}
              </div>
              <div class="stock-info-secondary" *ngIf="data.sim4g_activated_date">
                {{ data.sim4g_activated_date | date : "dd/MM/yyyy HH:mm" }}
              </div>
            </td>
            <td>
              <span
                class="font-size-12 badge badge-danger"
                *ngIf="data.status == '0'"
                >{{ "Chưa liên kết" | translate }}</span
              >
              <span
                class="font-size-12 badge badge-success"
                *ngIf="data.status == '1'"
                >{{ "Đã liên kết" | translate }}</span
              >
            </td>
            <td>
              <span
                *ngIf="getDeviceUsageStatus(data.has_been_used)"
                class="badge stock-usage-badge"
                [ngClass]="data.has_been_used == 1 ? 'badge-success' : 'badge-secondary'"
              >
                {{ getDeviceUsageStatus(data.has_been_used) }}
              </span>
              <div class="stock-info-secondary" *ngIf="data.reuse_category">
                {{ getReuseCategoryLabel(data.reuse_category) }}
              </div>
              <div class="stock-info-secondary" *ngIf="data.origin_order_type">
                {{ getOriginOrderTypeLabel(data.origin_order_type) }}
              </div>
            </td>
            <td *ngIf="role === 'user'">
              {{ data.version }}
            </td>
            <td>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</td>
            <td class="py-2 table-column" *ngIf="canManageStock">
              <div class="d-flex" style="gap: 5px">
                <a
                  class="font-size-18"
                  href="javascript: void(0);"
                  ngbTooltip="{{ 'FORM.Edit' | translate }}"
                  placement="bottom-left"
                  (click)="onEdit(data, content)"
                >
                  <i class="mdi mdi-account-edit"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate }}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
              Mật khẩu không được bỏ trống.
          </div> -->
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <div class="row custom-mb">
            <div class="col-4">
              <label class="col-form-label required_label">
                {{ "Loại thiết bị" | translate }}
              </label>
              <ng-select
                formControlName="deviceTypeId"
                class="w-100"
                (change)="getDeviceModels($event)"
                [ngClass]="{
                  'is-invalid': submitted && form.deviceTypeId.errors
                }"
              >
                <ng-option [value]="null" disabled
                  >Chọn loại thiết bị</ng-option
                >
                <ng-option
                  *ngFor="let item of listDevicesFilter"
                  [value]="item.value"
                >
                  {{ item.label }}
                </ng-option>
              </ng-select>
              <div
                *ngIf="submitted && form?.deviceTypeId.errors?.required"
                class="invalid-feedback d-block"
              >
                Vui lòng chọn loại thiết bị.
              </div>
            </div>
            <div class="col-4">
              <label class="col-form-label required_label">
                {{ "Loại model của loa" | translate }}
              </label>
              <ng-select
                formControlName="type"
                class="w-100"
                [ngClass]="{ 'is-invalid': submitted && form.type.errors }"
              >
                <ng-option [value]="null" disabled
                  >Chọn loại model của loa</ng-option
                >
                <ng-option *ngFor="let item of listModel" [value]="item.value">
                  {{ item.label }}
                </ng-option>
              </ng-select>
              <div
                *ngIf="submitted && form.type.errors?.required"
                class="invalid-feedback d-block"
              >
                Vui lòng chọn loại model của loa.
              </div>
            </div>
            <div class="col">
              <label class="col-form-label">
                {{ "Nhà mạng" | translate }}
              </label>
              <ng-select formControlName="network_provider" class="w-100">
                <ng-option [value]="'-1'">Chọn nhà mạng</ng-option>
                <ng-option
                  *ngFor="let item of network_provider"
                  [value]="item.value"
                >
                  {{ item.label }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                      (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                  <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                      (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentDeviceLinkHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Lịch sử liên kết thiết bị</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <p class="mb-3 text-muted">
      Thiết bị: <strong>{{ deviceLinkHistorySerial }}</strong>
    </p>
    <div class="table-responsive">
      <table class="table table-bordered table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th>#</th>
            <th>Mã đơn hàng</th>
            <th>Số điện thoại KH</th>
            <th>Họ tên KH</th>
            <th>Trạng thái</th>
            <th>Ngày liên kết</th>
            <th>Ngày huỷ liên kết</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of deviceLinkHistory; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ history.customer_order_id || "--" }}</td>
            <td>{{ history.user_phone || "--" }}</td>
            <td>{{ history.user_full_name || "--" }}</td>
            <td>
              <span
                class="badge"
                [ngClass]="history.device_is_deleted == 1 ? 'badge-danger' : 'badge-success'"
              >
                {{ history.device_is_deleted == 1 ? "Đã huỷ liên kết" : "Đang liên kết" }}
              </span>
            </td>
            <td>{{ history.device_created_at | date : "dd/MM/yyyy HH:mm" }}</td>
            <td>
              <ng-container *ngIf="history.device_is_deleted == 1; else noCancelDate">
                {{ history.device_updated_at | date : "dd/MM/yyyy HH:mm" }}
              </ng-container>
              <ng-template #noCancelDate>--</ng-template>
            </td>
          </tr>
          <tr *ngIf="!deviceLinkHistory.length">
            <td colspan="7" class="text-center text-muted py-4">
              Chưa có lịch sử liên kết cho thiết bị này.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị với cửa hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">Serial</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">Model</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="model"
                [ngClass]="{ 'is-invalid': submitted && form.model.errors }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Cửa hàng</label
            >
            <div class="col-md-10">
              <ng-select
                formControlName="version"
                [items]="listWs"
                bindLabel="name"
                bindValue="id"
                placeholder="Chọn cửa hàng"
                [ngClass]="{ 'is-invalid': submitted && form.version.errors }"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.code }} - {{ item.name }} - {{ item.leader }}
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            Đóng
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            Lưu
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
  <div class="modal-header">
    <h5 class="modal-title">List keyword of "{{ selectedIncident.name }}"</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalHis('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3" *ngIf="formNewKeyword">
      <h5 class="font-size-14">Add New Keyword</h5>
      <form
        [formGroup]="formNewKeyword"
        (submit)="onSubmitFormKeyword(2)"
        class="d-flex"
      >
        <input
          type="text"
          class="form-control form-control-sm"
          style="width: 250px"
          formControlName="name"
        />
        <button class="btn btn-primary btn-sm ml-3" style="width: 150px">
          Add
        </button>
      </form>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr>
            <th width="50">#</th>
            <th>Name</th>
            <!-- <th>Thời gian</th> -->
            <th width="170"></th>
          </tr>
        </thead>
        <tbody *ngFor="let data of dataKeyword; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>
              <ng-container
                *ngIf="
                  selectedKeyword?.id == data.id && formEditKeyword;
                  else normal
                "
              >
                <form
                  [formGroup]="formEditKeyword"
                  (submit)="onSubmitFormKeyword(1)"
                >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="name"
                  />
                </form>
              </ng-container>
              <ng-template #normal>{{ data.name }}</ng-template>
            </td>
            <!-- <td>{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
            <td>
              <div class="d-flex" style="gap: 10px">
                <a
                  class="btn btn-sm btn-success"
                  href="javascript: void(0);"
                  (click)="editKeyword(data, i)"
                >
                  <i class="mdi mdi-account-edit"></i
                  >{{ "FORM.Edit" | translate }}</a
                >
                <a
                  class="text-white btn btn-sm btn-danger"
                  (click)="onDeleteKeyword(data.id)"
                  ><i class="mdi mdi-delete"></i
                  >{{ "FORM.Delete" | translate }}</a
                >
              </div>
              <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                              <button>Xoá</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
